import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import { di } from '../../../state/inversify.config';
import { CreateIncidentDomainService } from '../createIncidentDomainService';
import { ReviewIncidentDumb } from '../dumb/reviewIncident.dumb';
import { Button } from '../../../components/button/button';

export function ReviewIncidentSmart() {
  const incidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );
  const { t } = useTranslation();
  const incidentCreationViewSelector =
    incidentDomainService.useIncidentCreateViewSelector();

  const selectedPlayerSelector =
    incidentDomainService.useSelectedPlayerSelector();

  const onPrev = () => {
    incidentDomainService.dispatchPreviousPageQuery();
  };

  return (
    <Box sx={{ m: 1 }}>
      <Grid component="form">
        <Grid item>
          <Typography variant="subtitle1">
            {t('incident.REVIEW_INCIDENT_INFORMATION')}
          </Typography>
        </Grid>
        <Grid item>
          <ReviewIncidentDumb
            incidentData={incidentCreationViewSelector}
            playerName={selectedPlayerSelector?.firstName}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            type="submit"
            fullWidth
            variant="text"
            onClick={onPrev}
            label={t('incident.REVIEW_INCIDENT_GO_BACK')}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
